import React from "react";
import _ from "underscore";
import { MaterialIcon } from "../materialIcon";
import GradedValue, { gradedComponent, GRADE_TYPES } from "./gradedValue";
import * as SurveyUtils from "../../utils/surveys";
import { Cell } from "../grids";

export default class ArrowTrend extends Cell {

    getTrend() {
        const data = this.props.row.data ?? {},
            lastScore = parseFloat(data.lastScoreValue),
            lastLastScore = parseFloat(data.lastLastScoreValue);

        if (!isNaN(lastScore) && !isNaN(lastLastScore)) {
            return lastScore - lastLastScore;
        } else {
            return 0
        }
    }

    getIcon(score) {
            const grade = SurveyUtils.gradeTrend(score);

            switch(grade) {
                case 1:
                    return "trending_down"
                case 5:
                    return "trending_up"
                case 0:
                default:
                    return "trending_flat"
            }
    }

    render() {
        const value = this.props.value? this.props.value : 0,
            trend = this.getTrend(),
            icon = this.getIcon(trend),
            IconComponent = gradedComponent(MaterialIcon);

        return(
            <div className="survey-catalog__last-score-cell">
                <GradedValue
                    className="survey-catalog__last-score"
                    value={value}
                    gradeType={GRADE_TYPES.SCORE}
                />
                <IconComponent
                    className="survey-catalog__last-score-icon"
                    icon={icon}
                    value={trend}
                    gradeType={GRADE_TYPES.TREND}
                    invert={true}
                />
            </div>
        )
    }
}